import { el, list } from 'redom';

import IconButton from 'generics/components/icon-button';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import './index.scss';

class Bookmark {

  constructor(viewer) {

    this.viewer = viewer;
    this.index = -1;

    this.textContent = el('label.ellipsis');
    this.deleteButton = IconButton.deleteButtonSmall({
      tabindex: -1,
      onClick: this.handleDeleteClick.bind(this)
    });

    this.el = el('.sent-messages-bookmark', {
      onclick: this.handleBookmarkClick.bind(this)
    }, [this.textContent, this.deleteButton]);

  }

  handleDeleteClick(event) {

    event.stopPropagation();

    this.viewer.deleteBookmark(this.index);

  }

  handleBookmarkClick(event) {

    if (event.target === this.deleteButton.el) {
      return;
    }

    const bookmark = this.viewer.bookmarks[this.index];
    this.viewer.onSelect(bookmark);

  }

  update(bookmark, index) {

    this.index = index;
    this.textContent.textContent = bookmark.textContent;

  }

}

class BookmarksViewer {

  constructor(configuration) {

    this.bookmarks = configuration.bookmarks;
    this.onSelect = configuration.onSelect;
    this.onDelete = configuration.onDelete;
    this.onClose = configuration.onClose;

    this.list = list('#sent-messages-bookmarks.hide-scrollbar', Bookmark, '_id', this);

    this.el = el('#sent-messages-bookmarks-viewer', [
      el('label#sent-messages-bookmarks-viewer-header', 'Bookmarks'),
      this.list
    ]);

    this.list.update(this.bookmarks);

  }

  deleteBookmark(index) {

    const bookmark = this.bookmarks[index];

    this.bookmarks.splice(index, 1);
    this.list.update(this.bookmarks);

    this.onDelete(bookmark);

  }

  handleClose() {
    this.onClose();
  }

  onmount() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.handleClose.bind(this));

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

}

export default BookmarksViewer;